import React, { useState } from "react";
import { Link } from "react-router-dom";
import { dummyOrders } from "../../../data/dummyData";
import "../Home/Homepage.css";
import "./OrderBookPage.css";

const formatDate = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

const OrderBookPage = () => {
  const [orders] = useState(dummyOrders);
  const [search, setSearch] = useState("");

  const filtered = orders.filter(
    (o) =>
      o._id?.toLowerCase().includes(search.toLowerCase()) ||
      o.user_email?.toLowerCase().includes(search.toLowerCase()) ||
      `${o.pay_currency}/${o.ask_currency}`.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <main className="dashboard-main dashboard-subpage">
      <section className="dashboard-hero">
        <div className="dashboard-hero__text">
          <p className="dashboard-hero__breadcrumb">
            <Link to="/dashboard/homepage">Dashboard</Link>
            <span style={{ margin: "0 0.35rem" }}>/</span>
            <span>OrderBook</span>
          </p>
          <h1 className="dashboard-hero__title">OrderBook</h1>
          <p className="dashboard-hero__subtitle">
            Live order book and open orders
          </p>
        </div>
        <div className="dashboard-hero__icon">
          <i className="fas fa-book" />
        </div>
      </section>

      <div className="dashboard-body">
        <section className="orderbook-section">
          <div className="orderbook-section__header">
            <div className="orderbook-section__title-wrap">
              <span className="orderbook-section__icon">
                <i className="fas fa-book-open" />
              </span>
              <h2 className="orderbook-section__title">Orders</h2>
            </div>
            <div className="orderbook-section__stats">
              <span className="orderbook-stat">
                <strong>{orders.length}</strong> Orders
              </span>
              <span className="orderbook-stat">
                <strong>{orders.filter((o) => o.status === "PENDING" || o.status === "PARTIAL").length}</strong> Open
              </span>
            </div>
          </div>
          <div className="orderbook-search-wrap">
            <i className="fas fa-search" />
            <input
              type="text"
              placeholder="Search by order ID, email or pair..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="orderbook-search-input"
            />
          </div>
          <div className="orderbook-table-wrap">
            <table className="orderbook-table">
              <thead>
                <tr>
                  <th>Order ID</th>
                  <th>Created</th>
                  <th>User ID</th>
                  <th>User Email</th>
                  <th>Pair</th>
                  <th>Side</th>
                  <th>Order Type</th>
                  <th>Price</th>
                  <th>Quantity</th>
                  <th>Filled</th>
                  <th>Remaining</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((row) => (
                  <tr key={row._id}>
                    <td><span className="orderbook-order-id">{row._id}</span></td>
                    <td>{formatDate(row.createdAt)}</td>
                    <td>{row.user_id}</td>
                    <td>{row.user_email}</td>
                    <td><strong>{row.pay_currency}/{row.ask_currency}</strong></td>
                    <td>
                      <span className={`orderbook-side orderbook-side--${row.side?.toLowerCase()}`}>
                        {row.side}
                      </span>
                    </td>
                    <td>{row.order_type}</td>
                    <td>{typeof row.price === "number" ? row.price.toLocaleString("en-IN", { minimumFractionDigits: 2 }) : row.price}</td>
                    <td>{typeof row.quantity === "number" ? row.quantity.toLocaleString("en-IN", { maximumFractionDigits: 4 }) : row.quantity}</td>
                    <td>{typeof row.filled === "number" ? row.filled.toLocaleString("en-IN", { maximumFractionDigits: 4 }) : row.filled}</td>
                    <td>{typeof row.remaining === "number" ? row.remaining.toLocaleString("en-IN", { maximumFractionDigits: 4 }) : row.remaining}</td>
                    <td>
                      <span className={`orderbook-status orderbook-status--${(row.status || "").toLowerCase()}`}>
                        {row.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {filtered.length === 0 && (
            <p className="orderbook-empty">No orders match your search.</p>
          )}
        </section>
      </div>
    </main>
  );
};

export default OrderBookPage;
